export default __webpack_public_path__ + "static/media/adv-1.f445f209.jpg";